import React from 'react';
import DatePicker from '@lib/components/DateTimePicker/DatePicker';
import { InputTypes } from '@lib/components/Input/enums';
import { ComponentProps, defaultProps } from '../types';

export default function DatePreview({ t }: ComponentProps) {
  return (
    <DatePicker
      {...defaultProps}
      label={t('select-date')}
      type={InputTypes.date}
    />
  );
}
